// TOP LEVEL IMPORTS
import React from 'react';
import GeneralHelpers from 'lib/helpers/GeneralHelpers';
// ANTD
import Form from 'antd/lib/form';
import Select from 'antd/lib/select';
import Caption from 'components/text/Caption';

// CONSTANTS AND DESTRUCTURING
// ================================================================
const Option = Select.Option;
const FormItem = Form.Item;

const CONTRACT_SESSION_TYPES = ['Portrait', 'Wedding', 'Event', 'Newborn', 'Boudoir', 'Real Estate'];

// EXPORTED COMPONENT
// ================================================================
const ContractTypeInput = props => {
  const { onChange, value, initialValue } = props;

  return (
    <div>
      <Select
        onChange={onChange}
        value={value || initialValue}
        showSearch
        size="large"
        optionFilterProp="children"
        style={{ width: '100%' }}
        filterOption={GeneralHelpers.selectSearchFilter}
      >
        {CONTRACT_SESSION_TYPES.map(item => (
          <Option key={item}>{item}</Option>
        ))}
      </Select>
    </div>
  );
};

// EXPORT
// ================================================================
export default ContractTypeInput;



// WEBPACK FOOTER //
// ./src/components/inputs/ContractTypeInput/index.js